<template>
  <div v-if="isInstructor" class="ion-padding-horizontal">
    <div data-testid="share-profile-block" class="ion-padding-top share-profile-block">
      <!-- <ion-textarea
        readonly="true" :value="profileLink" label="My Profile Link"
        label-placement="stacked" rows="2" mode="md"
        fill="outline" class="ion-margin-top"
      /> -->
      <ion-button
        color="success" expand="block" fill="outline"
        @click="shareProfileLink"
      >
        Share My Profile
      </ion-button>
      <ion-note class="share-profile-block__note">
        You can send this link to students to invite them to book with you. The link can be shared via Chat, Email or Text Message.
      </ion-note>
      <ion-button
        class="share-profile-block__preview"
        color="dark" fill="clear" expand="block"
        :href="profileLink"
        target="_blank"
        rel="noopener"
      >
        Visit my profile as a student
        <ion-icon slot="end" :icon="openOutline" />
      </ion-button>
    </div>
  </div>
</template>

<script setup>
import { IonButton, IonIcon, IonNote } from '@ionic/vue'
import { computed } from 'vue'

import { openOutline } from 'ionicons/icons'

import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

const isInstructor = computed(() => userStore.is.type === 'instructor')
const profileLink = computed(() => `${location.origin}/my/instructors/${userStore.userData().id}`)

async function shareProfileLink() {
  try {
    await navigator.share({ url: profileLink.value })
  } catch (err) {
    console.log(err)
  }
}
</script>

<style scoped>
.share-profile-block {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.share-profile-block__note {
  line-height: 1.5;
  color: rgba(19, 38, 30, 0.75);
}

.share-profile-block__preview {
  font-weight: 600;
  letter-spacing: 0.02em;
  justify-content: center;
  text-transform: none;
}

.share-profile-block__preview :deep(ion-icon) {
  margin-left: 0.35rem;
}
</style>
